import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import { colors } from './index.js';
import { responsive } from './index.js';
export const HintDialogueBtnCmp = styled.a.withConfig({
  displayName: "hint__HintDialogueBtnCmp",
  componentId: "sc-1aap1aa-0"
})(["width:35px;height:35px;position:absolute;right:0;border-radius:50%;border:2px dotted rgba(0,0,0,0.2);z-index:99;display:flex;align-items:center;text-align:center;justify-content:center;color:rgba(0,0,0,0.2);cursor:pointer;&:hover{border:2px dotted transparent;background:#fff;color:", ";box-shadow:0 2px 4px rgba(0,0,0,0.1);}"], colors.frostbite);
export const HintDialogueBtn = ({
  action
}) => {
  return /*#__PURE__*/React.createElement(HintDialogueBtnCmp, {
    onClick: action
  }, "?");
};
export const Hint = styled.div.withConfig({
  displayName: "hint__Hint",
  componentId: "sc-1aap1aa-1"
})(["display:flex;flex-direction:column;transform:translateY(-5%);max-width:480px;", "{padding:20px;}"], responsive.xs);
export const HintButton = styled.span.withConfig({
  displayName: "hint__HintButton",
  componentId: "sc-1aap1aa-2"
})(["padding-top:25px;display:block;a{padding:15px 25px;border-radius:35px;background:#fff;box-shadow:2px 2px 4px rgba(0,0,0,0.1);font-weight:600;text-decoration:none !important;color:", ";}"], colors.frostbite);
export const HintContent = styled.div.withConfig({
  displayName: "hint__HintContent",
  componentId: "sc-1aap1aa-3"
})(["max-width:500px;position:relative;h2{font-size:30px;color:", ";font-weight:600;font-family:'Roboto Slab',serif;margin:0;padding-top:12px;}p{margin:0;line-height:1.5em;color:", ";padding:10px 0 25px;span{cursor:pointer;color:", ";text-decoration:underline;}}", "{padding:20px;}"], colors.frostbite, colors.frostbite, colors.glacier, responsive.xs);
export const HintImg = styled.div.withConfig({
  displayName: "hint__HintImg",
  componentId: "sc-1aap1aa-4"
})(["width:100%;display:block;max-width:400px;img{width:100%;}", "{margin-top:100px;padding:0 50px;}"], responsive.xs);